import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { AppState } from 'store'
import styled from 'styled-components'
import CheckBox from '../../UI/CheckBox'
import { Modal } from '../../UI/Modal'
import { Button } from '../../UI/Button'
interface State {
  isCheck: boolean
  showModal: boolean
  modalContent: string
}
class PrivacyPolicyCheckBox extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isCheck: false,
      showModal: false,
      modalContent: ''
    }
  }

  handleInputChange = () => {
    this.setState(state => ({ isCheck: !state.isCheck }))
    this.props.isCheck(this.state.isCheck)
  }

  onShowModal = (content: string) =>
    this.setState({ showModal: true, modalContent: content })
  onCloseModal = () => this.setState({ showModal: false })
  render() {
    const { privacyPolicy, term, errorLabel } = this.props
    const { showModal, modalContent } = this.state
    const Term = (
      // tslint:disable-next-line:jsx-no-lambda
      <A onClick={() => this.onShowModal(privacyPolicy.htmlDocument)}>
        Term of Services
      </A>
    )
    const Policy = (
      // tslint:disable-next-line:jsx-no-lambda
      <A onClick={() => this.onShowModal(term.htmlDocument)}>Privacy Policy</A>
    )
    return (
      <Fragment>
        <Modal
          modal={{
            title: '',
            content: (
              <Scroll dangerouslySetInnerHTML={{ __html: modalContent }} />
            ),
            footer: (
              <Fragment>
                <Button variant={'text'} onClick={this.onCloseModal}>
                  Cancel
                </Button>
              </Fragment>
            )
          }}
          isOpen={showModal}
        />
        <CheckBox
          isCheck={this.state.isCheck}
          onChange={this.handleInputChange}
          errorLabel={errorLabel}
        />
        <Text>
          I agree to Continuum Health Technologies {Term} and {Policy}.
        </Text>
      </Fragment>
    )
  }
}
// I agree to Continuum Health Technologies Terms of service and Privacy Policy
// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}

type StateProps = ReturnType<typeof mapStateToProps>
interface ParentProps {
  isCheck: any
  errorLabel: string
}
export type Props = StateProps & ReceivedProps & ParentProps

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  privacyPolicy: state.privacyPolicy.privacyPolicy,
  term: state.privacyPolicy.term
})

export default connect(
  mapStateToProps
)(PrivacyPolicyCheckBox)

const A = styled.a`
  color: #41aada;
  cursor: pointer;
`
const Scroll = styled.div`
  display: block;
  //width: 350px;
  height: 400px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  line-height: normal;
`
const Text = styled.label`
  color: #7f7f7f;
  font-size: 1rem;
  font-weight: 900;
  //margin-bottom: 0.5rem;
  margin: 0.5rem;
  //display: block;
  display: inline-block;
  width: 500px;
`
